import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  listConversationsApi,
  getConversationApi,
  createConversationApi,
  sendMessageApi,
  listMessagesApi,
  markConversationReadApi,
  getUnreadConversationsAndMessagesApi,
} from '@nxsys/services/api/message';
import {
  CreateConversationParams,
  ListConversationsParams,
  SendMessageParams,
  ListMessagesParams,
} from '../types';

// ==================== Conversation Actions ====================

export const listConversations = createAsyncThunk(
  'conversation/listConversations',
  async (params: ListConversationsParams, { rejectWithValue }) => {
    try {
      const response = await listConversationsApi(params);
      return { ...response, isLoadMore: !!params.cursor };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const getConversation = createAsyncThunk(
  'conversation/getConversation',
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await getConversationApi(id);
      return response;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const createConversation = createAsyncThunk(
  'conversation/createConversation',
  async (params: CreateConversationParams, { rejectWithValue }) => {
    try {
      const response = await createConversationApi(params);
      return response;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const sendMessage = createAsyncThunk(
  'conversation/sendMessage',
  async (params: SendMessageParams, { rejectWithValue }) => {
    try {
      const { conversationId, ...data } = params;
      const response = await sendMessageApi(conversationId, data);
      return { ...response, _uuid: params.uuid };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const loadMessages = createAsyncThunk(
  'conversation/loadMessages',
  async (params: ListMessagesParams, { rejectWithValue }) => {
    try {
      const { conversationId, ...queryParams } = params;
      const response = await listMessagesApi(conversationId, queryParams);
      return { ...response, isLoadMore: !!params.cursor };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const markConversationRead = createAsyncThunk(
  'conversation/markConversationRead',
  async (
    { id, userId, agencyId }: { id: number; userId: string; agencyId?: string },
    { dispatch, rejectWithValue },
  ) => {
    try {
      await markConversationReadApi(id);
      // Refresh global unread count after marking as read
      dispatch(fetchUnreadCount());
      return { id, userId, agencyId };
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

export const fetchUnreadCount = createAsyncThunk(
  'conversation/fetchUnreadCount',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getUnreadConversationsAndMessagesApi();
      return response;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);
